import moment from 'moment';
export const formatTimeDifference = (date) => {
    const now = moment(new Date());
    const givenDate = moment(date.replace('UTC', '').trim().replace(' ', 'T') + ':00Z');
    const diffMinutes = now.diff(givenDate, 'minutes');
    const diffHours = now.diff(givenDate, 'hours');
    const diffDays = now.diff(givenDate, 'days');
    if (diffMinutes < 60) {
        return `${diffMinutes}m`;
    }
    else if (diffHours < 24) {
        return `${diffHours}h`;
    }
    else {
        return `${diffDays}d`;
    }
};
export const fixDateString = (date) => date.replace(' UTC', '').replace(' ', 'T') + ':00.00Z';
export const getTimeElapsed = (date) => {
    const startDate = new Date(date.replace(' ', 'T') + '.00Z');
    const currentTime = new Date();
    return Math.floor((currentTime.getTime() - startDate.getTime()) / 1000);
};
